export default (context, bool, text='') => {
    context.overlayLoading = bool
    context.overlayMessage = text
}